import React, { useEffect, useState } from 'react';
import firebase from '../config/Firebase';
import Loading from './Loading';
import VerifyPopup from './VerifyPopup';
import '../css/EditItinerary.css';

// Components Imports
import TitleEditor from './FormComponents/TitleEditor';
import HeaderForm from './FormComponents/HeaderForm';
import ButtonForm from './FormComponents/ButtonForm';
import { fieldsEditItinerary } from './FieldsForm/itinerary.fields';

import { inputsComponents } from '../utils/formManager';
import { handleEditRoutes, handlesSaveRoutes } from '../utils/pendencyManager';

export default function EditItinerary({ setEditPopup, doc, action, userCity, pendency, objectPend, setObjectPend, setNumPendency, role, routeID, route }) {
  const [popup, setPopup] = useState(false);
  const [item, setItem] = useState(handleItem());
  const [file, setFile] = useState();

  useEffect(() => {
    setItem(handleItem(doc));
  }, [doc]);

  function handleItem() {
    if (objectPend)
      return objectPend.currDoc;
  
    return doc || {
      docId: '',
      titulo: '',
      idRota: routeID,
      'Short Descr': '',
      descrHistorico: '',
      descrPercurso: '',
      descrConteudo: '',
      descrDestaques: '',
      Active: true,
      pontosRota: [],
      pontosRotaDuracao: [],
      pontosApoio: [],
      guiasAgencias: [],
      waypoint: [],
      waypointTitulo: [],
      original: {
        'Short Descr': '',
        descrHistorico: '',
        descrPercurso: '',
        descrConteudo: '',
        descrDestaques: '',
      },
    };
  }

  const handleEditItinerary = async () => {
    try {
      const docData = await handleUploadFiles();
      await handleEditRoutes(doc.docId, doc, docData);
      setEditPopup(false);
    } catch (error) {
      setEditPopup(false);
    }
  };

  const handleAddItinerary = async () => {
    try {
      const docData = await handleUploadFiles();
      await handlesSaveRoutes(docData);
      setEditPopup(false);
    } catch (error) {
      setEditPopup(false);
    }
  };

  useEffect(() => {
    if (action === 'Criar' && !objectPend)
      setItem({ ...item, City: userCity });
  }, [userCity]);

  function handleCheckFields() {
    const keys = ['titulo', 'Short Descr'];
    for (let i = 0; i < keys.length; i++) {
      if ((item[keys[i]] === '' || item[keys[i]] === 0) || item[keys[i]] === null || !item[keys[i]]) {
        document.getElementById(keys[i] + 'Form').focus();
        return;
      }
    }

    if (!item.pontosRota || item.pontosRota.length < 2) {
      document.getElementById('pontosRotaForm').focus();
      return;
    }

    if (!item.pontosRotaDuracao.every((duration) => duration !== '')) {
      document.getElementById('pontosRotaDuracaoForm').focus();
      return;
    }

    if (objectPend)
      handleEditPendency();
    else
      setPopup(true);
  }

  async function handleEditPendency() {
    const newPendency = { ...objectPend, currDoc: item };
    setObjectPend(newPendency);
    await firebase.firestore().collection('Pendencies').doc(pendency.id).set(newPendency)
      .then(() => setEditPopup(false));
  }

  async function handleGPXFile(file) {
    const ref = firebase.storage().ref(`roteiros/${routeID}/${'gpxFile_' + item.titulo}`);
    await ref.put(file);

    const url = await ref.getDownloadURL();

    return url;
  }

  async function handleUploadFiles() {
    let aux = item;
    if (file)
      aux = { ...aux, GPXFile: await handleGPXFile(file) };

    return aux;
  }

  if (!userCity) {
    return <Loading />;
  }

  return (
    <div className='EditInventory'>
      <div className='bodyEditInventory'>
        <TitleEditor action={action} type={'RoteirosTrechos'} />
        <div>
          <form className='form_edit_admin'>
            <HeaderForm />
            {
              fieldsEditItinerary.map((field) => {
                return inputsComponents[field.component]({ term: field, item: item, setItem: setItem, doc: doc, userCity: action === 'Criar' && !objectPend ? userCity : item.City, objectPend: objectPend, action: action === 'Criar', role: role, actionType: action, userRole: role, route: route.length ? { Cities: route } : route.data(), setFile: setFile });
              })
            }
            { popup ? <VerifyPopup setVerifyPopup={setPopup} handleAction={doc ? handleEditItinerary : handleAddItinerary} title={'Deseja gravar as alterações ?'} message={'As informações desse formulário serão gravadas e poderão ser visualizadas posteriormente. Deseja continuar?'} /> : null }
            <ButtonForm setEditPopup={setEditPopup} handleCheckFields={handleCheckFields} />
          </form>
        </div>
      </div>
    </div>
  );
}